import styled from 'styled-components';

import { screenSizes } from '../../theme/screen';

export const Head = styled.div`
  width: 100%;
  margin: 0 auto;
  padding: 30px;

  & .head-container {
    display: flex;
    justify-content: center;
    align-items: center;
    margin-bottom: 70px;
    flex-direction: column;
    gap: 20px;
  }
  & .head-title {
    text-align: center;
    font-size: 32px;
    max-width: 900px;
    line-height: 50px;
    font-weight: 600;
  }

  & .head-desc {
    font-size: 16px;
    max-width: 1050px;
    line-height: 20px;
  }
  @media (max-width: ${screenSizes.sm}) {
    & .head-title {
      font-size: 18px;
      line-height: 32px;
    }
    & .head-desc {
      font-size: 14px;
    }
  }
`;

export const MainContainer = styled.div`
  max-width: 1300px;
  margin: 0 auto;
  padding: 0;
  @media (min-width: ${screenSizes.md}) {
    padding: 30px;
  }
`;
export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  margin-bottom: 100px;
  padding: 30px;
  @media (min-width: ${screenSizes.lg}) {
    padding: 20px;
  }

  @media (min-width: ${screenSizes.lg}) {
    flex-direction: row;
    justify-content: flex-start;
    gap: 30px;
  }
`;

export const TabsContainer = styled.div`
  position: relative;
  top: auto;
  background-color: #e9f4ff;
  padding: 20px;
  max-width: 400px;
  height: 300px;
  overflow-y: auto;
  flex-shrink: 0;
  margin-bottom: 50px;

  & .tab-container-title {
    color: #20435d;
    font-size: 20px;
    min-width: 250px;
    font-weight: 600;
  }
  @media (min-width: ${screenSizes.md}) {
    margin-top: 0px;
    margin-bottom: 50px;
  }
  @media (min-width: ${screenSizes.lg}) {
    position: sticky;
    top: 100px;
  }
  @media (min-width: ${screenSizes.sm}) {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
`;

export const Tab = styled.div<{ isActive: boolean }>`
  padding: 10px;
  cursor: pointer;
  min-width: 300px;
  font-size: 16px;

  & .category-tabs-title {
    font-size: 14px;
    font-weight: 500;
    margin-left: 18px;
    color: ${({ isActive, theme }) =>
    isActive ? theme.colors.primary : theme.colors.blue};
  }
`;

export const FAQContainer = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 80px;
  border-radius: 10px;

  & .faq-category {
    font-size: 20px;
    color: #20435d;
    font-weight: 600;
  }
  @media (min-width: ${screenSizes.sm}) {
    & .faq-category {
      font-size: 32px;
    }
  }
`;

export const FAQContent = styled.div``;

export const LastSection = styled.div`
  background-color: #f3f9fd;
  width: 100%;
  padding: 50px 0px;
  margin: 0 auto;

  & .content {
    display: flex;
    flex-direction: column;
    gap: 25px;
    justify-content: center;
    align-items: center;
  }

  & .content-title {
    font-size: 32px;
    font-weight: 600;
  }
  & .content-desc {
    font-size: 20px;
    font-weight: 500;
    text-align: center;
  }
  @media (max-width: ${screenSizes.md}) {
    & .content-desc {
      font-size: 16px;
    }
    & .content-title {
      font-size: 32px;
      font-weight: 600;
    }
  }
  @media (max-width: ${screenSizes.sm}) {
    & .content-title {
      font-size: 20px;
      font-weight: 600;
    }
    & .content-desc {
      font-size: 14px;
    }
  }
`;
